import { Button, ErrorBox } from "@gearbox-protocol/deploy-tools-ui";
import type { FC } from "react";
import { Link, useRouteError } from "react-router-dom";

const CloneErrorBox: FC = () => {
  const err = useRouteError();
  return (
    <div className="flex flex-col flex-1 rounded-xl bg-background p-4 gap-y-2">
      <ErrorBox error={err} />

      <Button asChild variant="secondary" className="self-start w-64">
        <Link to="/new-fork">Start a blank fork</Link>
      </Button>
    </div>
  );
};

export default CloneErrorBox;
